var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5e0c654cef0a2d2db74f6691e6e8abd770d987db"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["base-frontend@good-it-works"]={id:"5e0c654cef0a2d2db74f6691e6e8abd770d987db"};
      